import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';
// Response / Request
import { Result } from '@models/common/resultResponse';
import { MenuItemResponse, MenuResponse } from '@/main/models/response/menu';
import { errorBoundaryReduxSaga, getTranslateByKey, renderErrorReduxSaga } from '@/main/services/utils';

// Redux
import { saveMenu } from './index';

// Api's
import { screensApi } from '../../api';

// Utils
import { RoutesConstants } from '@/main/routes/routesConstants';

// Enum
import { OrderStepsEnum } from '@/main/services/enum/OrderStepsEnum';

export function* getMenuSaga() {
  try {
    const response: AxiosResponse<Result<MenuResponse[]>> = yield call(
      screensApi.getScreens
    );

    const menuData = {
      idModule: 0,
      name: getTranslateByKey('information.home'),
      sort: 1,
      screens: [],
      route: '/'
    };

    const menuResponse = response.data.result.map((menu: MenuResponse) => {
      if (menu.screens && menu.screens.length > 0) {
        let screens: MenuItemResponse[] = [];

        menu.screens.forEach((menuItem: MenuItemResponse) => {
          if (menuItem.route === RoutesConstants.orderCreateOrder) {
            screens.push({
              ...menuItem,
              route: `${RoutesConstants.orderCreateOrder}?step=${OrderStepsEnum.VehicleInformation}`
            });
          } else {
            screens.push(menuItem);
          }
        });

        return { ...menu, screens };
      }

      return menu;
    });

    const responseFormatted = [menuData, ...menuResponse];

    if (responseFormatted) {
      yield put(saveMenu(responseFormatted, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveMenu(null, true, resultError.messagesDataError));
    }
  }
}
